/*
  Wires up the "Lisää koriin" (Add to cart) button rendered under each
  product card in collection / all-products grids (snippets/product-grid-item.liquid).
  Reuses theme.AjaxProduct so behavior matches the main product form:
  loading state, inline errors, and auto-open of the cart drawer via the
  theme's existing global "ajaxProduct:added" listener.

  This script tag is deferred and placed after theme.js in layout/theme.liquid,
  so by the time it runs the DOM is fully parsed and theme.AjaxProduct is
  already defined - no need to wait for DOMContentLoaded or theme's
  one-shot "page:loaded" event (which theme.js can dispatch synchronously
  during its own deferred execution, before a later script could listen for it).
*/
(function initGridQuickAdd() {
  document.querySelectorAll('.grid-product__quick-add-form').forEach(function (form) {
    if (form.dataset.quickAddInit) return;
    form.dataset.quickAddInit = 'true';
    new theme.AjaxProduct(form);
  });
})();
